/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PostApiProjectsMutationRequest,
  PostApiProjectsMutationResponse,
} from '../models/PostApiProjects.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  postApiProjectsMutationResponseSchema,
  postApiProjectsMutationRequestSchema,
} from '../zod/postApiProjectsSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const postApiProjectsMutationKey = () =>
  [{ url: '/api/projects' }] as const;

export type PostApiProjectsMutationKey = ReturnType<
  typeof postApiProjectsMutationKey
>;

/**
 * {@link /api/projects}
 */
export async function postApiProjects(
  data: PostApiProjectsMutationRequest,
  config: Partial<RequestConfig<PostApiProjectsMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = postApiProjectsMutationRequestSchema.parse(data);
  const res = await request<
    PostApiProjectsMutationResponse,
    ResponseErrorConfig<Error>,
    PostApiProjectsMutationRequest
  >({
    method: 'POST',
    url: `/api/projects`,
    data: requestData,
    ...requestConfig,
  });
  return postApiProjectsMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projects}
 */
export function usePostApiProjects<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiProjectsMutationResponse,
      ResponseErrorConfig<Error>,
      { data: PostApiProjectsMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<PostApiProjectsMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiProjectsMutationKey();

  return useMutation<
    PostApiProjectsMutationResponse,
    ResponseErrorConfig<Error>,
    { data: PostApiProjectsMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postApiProjects(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
